import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FieldConfig } from '../../interface/field.interface';
import { environment } from 'src/environments/environment.prod';
import { Router } from '@angular/router';
// text,email,tel,textarea,password,
@Component({
  selector: 'app-file',
  template: `
    <ngx-dropzone
      id="ngx-dropzone_1"
      [maxFileSize]="10000000"
      class="dropzone-custom dropzone dropzone-primary"
      [accept]="acceptedFileTypes"
      [multiple]="environment?.otm === 'fjsti' ? true : false"
      (change)="onSelect($event)"
    >
      <ngx-dropzone-label>
        <div class="dz-message needsclick">
          <i class="fa fa-cloud-upload"></i>
          <h4 class="mb-0 f-w-600">
            Fayllarni bu yerga tashlang yoki yuklash uchun bosing.
          </h4>
        </div>
      </ngx-dropzone-label>
      <ngx-dropzone-preview
        *ngFor="let f of files"
        [removable]="true"
        (removed)="onRemove(f)"
      >
        <ngx-dropzone-label
          style="width: 160px; height: 120px; overflow:hidden;"
          >{{ f.name }}</ngx-dropzone-label
        >
      </ngx-dropzone-preview>
    </ngx-dropzone>
    <div class="red fileError" *ngIf="error">
      {{ error }}
    </div>
  `,
  styles: [
    `
      .dropzone {
        padding: 20px;
      }
      .dropzone-custom {
        margin-bottom: 10px;
        height: 200px;
        overflow-x: initial;
      }
      .flex {
        display: flex;
      }
      .red {
        color: red;
      }
      .fileError {
        padding-bottom: 10px;
      }
      @media only screen and (max-width: 767px) {
        .dropzone-custom {
          width: 95%;
          margin: 0 auto 10px auto;
        }
      }
    `,
  ],
})
export class FileComponent implements OnInit {
  field: FieldConfig;
  group: FormGroup;
  environment;
  isHovering;
  files: File[] = [];
  error;
  acceptedFileTypes: string;

  constructor(private router: Router) {}

  ngOnInit() {
    this.environment = environment;
    // Check if URL contains '4d2' to determine accepted file types
    const currentUrl = this.router.url;
    if (currentUrl.includes('4d2')) {
      this.acceptedFileTypes =
        'application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document';
    } else {
      this.acceptedFileTypes = 'application/pdf';
    }
  }

  toggleHover(e) {}

  onSelect(event) {
    this.error = '';
    console.log('reason', event.addedFiles);
    if (event.rejectedFiles[0]) {
      if (event.rejectedFiles[0].reason === 'type') {
        const errorMsg = this.router.url.includes('4d2')
          ? 'fayl turlarini yuklashingiz mumkin: application/pdf, application/msword (.doc, .docx)'
          : 'fayl turlarini yuklashingiz mumkin: application/pdf';
        this.error = errorMsg;
        return;
      }
      if (event.rejectedFiles[0].reason === 'size') {
        this.error = '10mb gacha fayl yuklashingiz mumkin';
        return;
      }
    }
    if (this.environment?.otm !== 'fjsti' && this.files.length > 0) {
      this.error =
        "Bitta pdf yuklash mumkin, Hamma fayllaringizni bitta pdf faylga joylashtirib jo'nating";
      this.group.controls[this.field.type].setValue(this.files);
      return;
    }
    this.files.push(...event.addedFiles);
    this.group.controls[this.field.type].setValue(this.files);
  }

  onRemove(event) {
    this.files.splice(this.files.indexOf(event), 1);
    this.group.controls[this.field.type].setValue(this.files);
  }
}
